module.exports = {
  isStartMock: false,
  baseApi: '/api',
};
